// src/pages/micuenta/MiCuentaUsuarioMenu.jsx
import { Link } from "react-router-dom";
import {
  FaUser,
  FaCog,
  FaCreditCard,
  FaFileInvoiceDollar,
  FaBell,
  FaFileUpload,
  FaBriefcase,
  FaHeart,
  FaChevronRight,
} from "react-icons/fa";
import "./micuentausuarioempleador.css";

function MiCuentaUsuarioMenu() {
  return (
    <>
      <h1 className="account-title">
        MI CUENTA <span className="account-subtitle">(Usuario)</span>
      </h1>

      {/* Grupo: Perfil Profesional (movido al inicio) */}
      <div className="account-group">
        <h2 className="group-title">Perfil Profesional</h2>
        <Link to="/mi-cuenta/curriculum" className="account-link">
          <div className="account-button">
            <div className="button-left">
              <FaFileUpload className="button-icon" />
              <span className="button-text">Subir Currículum</span>
            </div>
            <div className="button-right">
              <FaChevronRight />
            </div>
          </div>
        </Link>
      </div>

      {/* Grupo: Empleo (segundo en la lista) */}
      <div className="account-group">
        <h2 className="group-title">Empleo</h2>
        <Link to="/mi-cuenta/empleos-aplicados" className="account-link">
          <div className="account-button">
            <div className="button-left">
              <FaBriefcase className="button-icon" />
              <span className="button-text">Empleos Aplicados</span>
            </div>
            <div className="button-right">
              <FaChevronRight />
            </div>
          </div>
        </Link>
        <Link to="/mi-cuenta/favoritos" className="account-link">
          <div className="account-button">
            <div className="button-left">
              <FaHeart className="button-icon" />
              <span className="button-text">Favoritos</span>
            </div>
            <div className="button-right">
              <FaChevronRight />
            </div>
          </div>
        </Link>
      </div>


        {/* Grupo: Suscripción */}
        <div className="account-group">
        <h2 className="group-title">Suscripción</h2>
        <Link to="/mi-cuenta/suscripciones" className="account-link">
          <div className="account-button">
            <div className="button-left">
              <FaBell className="button-icon" />
              <span className="button-text">Suscripción</span>
            </div>
            <div className="button-right">
              <FaChevronRight />
            </div>
          </div>
        </Link>
      </div>

      {/* Grupo: Maneja tu cuenta */}
      <div className="account-group">
        <h2 className="group-title">Maneja tu cuenta</h2>
        <Link to="/mi-cuenta/datos-personales" className="account-link">
          <div className="account-button">
            <div className="button-left">
              <FaUser className="button-icon" />
              <span className="button-text">Datos Personales</span>
            </div>
            <div className="button-right">
              <FaChevronRight />
            </div>
          </div>
        </Link>
        <Link to="/mi-cuenta/configuracion-seguridad" className="account-link">
          <div className="account-button">
            <div className="button-left">
              <FaCog className="button-icon" />
              <span className="button-text">Configuración de Seguridad</span>
            </div>
            <div className="button-right">
              <FaChevronRight />
            </div>
          </div>
        </Link>
      </div>


      {/* Grupo: Información de Pago */}
      <div className="account-group">
        <h2 className="group-title">Información de Pago</h2>
        <Link to="/mi-cuenta/metodos-pago" className="account-link">
          <div className="account-button">
            <div className="button-left">
              <FaCreditCard className="button-icon" />
              <span className="button-text">Métodos de Pago</span>
            </div>
            <div className="button-right">
              <FaChevronRight />
            </div>
          </div>
        </Link>
        <Link to="/mi-cuenta/facturacion" className="account-link">
          <div className="account-button">
            <div className="button-left">
              <FaFileInvoiceDollar className="button-icon" />
              <span className="button-text">Facturación</span>
            </div>
            <div className="button-right">
              <FaChevronRight />
            </div>
          </div>
        </Link>
      </div>


    </>
  );
}

export default MiCuentaUsuarioMenu;